export const LOCAL_STORAGE_KEYS = {
  COOKIES_ALERT: 'isShowCookiesAlert',
};
